export default __webpack_public_path__ + "static/candiaturespontanee-dc50ba1605b324f80bad363b3974b871.jpg";